export default __webpack_public_path__ + "media/images/testimonials/egg-bg-7824a6c822f3f4d44a839ede4ce110dc.svg";